import { render, staticRenderFns } from "./provoffConfirm.vue?vue&type=template&id=a47ececc&"
import script from "./provoffConfirm.vue?vue&type=script&lang=js&"
export * from "./provoffConfirm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports